import { makeStyles } from '@material-ui/core/styles';
import { Card, CardActionArea, CardContent, Typography, Chip, Box } from '@material-ui/core';
import { Link } from '@backstage/core-components';

const useStyles = makeStyles(theme => ({
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    transition: 'transform 0.2s, box-shadow 0.2s',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: theme.shadows[6],
    },
  },
  cardAction: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
  },
  content: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  date: {
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
    marginBottom: theme.spacing(1),
  },
  title: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    lineHeight: 1.3,
  },
  excerpt: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    flexGrow: 1,
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
  tags: {
    marginTop: theme.spacing(2),
    display: 'flex',
    gap: theme.spacing(0.5),
    flexWrap: 'wrap',
  },
  tag: {
    height: 24,
    fontSize: '0.7rem',
  },
}));

export interface BlogPost {
  title: string;
  date: string;
  excerpt: string;
  href: string;
  tags?: string[];
}

interface BlogPostCardProps {
  post: BlogPost;
}

export const BlogPostCard = ({ post }: BlogPostCardProps) => {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardActionArea
        className={classes.cardAction}
        component={Link}
        to={post.href}
      >
        <CardContent className={classes.content}>
          <Typography className={classes.date}>{post.date}</Typography>
          <Typography variant="h6" className={classes.title}>
            {post.title}
          </Typography>
          <Typography className={classes.excerpt}>{post.excerpt}</Typography>
          {post.tags && post.tags.length > 0 && (
            <Box className={classes.tags}>
              {post.tags.map(tag => (
                <Chip
                  key={tag}
                  label={tag}
                  size="small"
                  className={classes.tag}
                  variant="outlined"
                />
              ))}
            </Box>
          )}
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
